const CATEGORY_OPTIONS = [
  "Atrasos",
  "Avisos",
  "Faturas",
  "Inadimplências",
  "Marketing",
  "Outros",
];

function toBoolean(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;

  const normalized = String(value || "").trim().toLowerCase();
  return ["true", "1", "sim", "yes"].includes(normalized);
}

function normalizeDateOnly(value) {
  if (!value) return "";

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString().slice(0, 10);
  }

  const stringValue = String(value);
  const isoDateMatch = stringValue.match(/^\d{4}-\d{2}-\d{2}/);
  if (isoDateMatch) return isoDateMatch[0];

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  return date.toISOString().slice(0, 10);
}

function inferScheduleType(campaign) {
  const startDate = normalizeDateOnly(
    campaign?.start_date || campaign?.startDate || campaign?.initial_date,
  );
  const expirationDate = normalizeDateOnly(
    campaign?.expiration_date || campaign?.end_date || campaign?.endDate,
  );

  if (startDate && expirationDate && startDate !== expirationDate) {
    return "recurring";
  }

  if (toBoolean(campaign?.business_days) || toBoolean(campaign?.dynamic_date)) {
    return "recurring";
  }

  if (startDate && expirationDate && startDate === expirationDate) {
    return "single";
  }

  if (toBoolean(campaign?.start_immediately)) {
    return "single";
  }

  return "";
}

function getTimeValue(startDate, startTime) {
  if (!startDate || !startTime) return null;

  const normalizedTime = String(startTime).slice(0, 5);
  return `${startDate}T${normalizedTime}:00`;
}

export function getEmptyCampaignWizardData() {
  return {
    basic: {},
    schedule: {},
    audience: {},
    sendRules: {},
    channels: {
      sendWhatsapp: false,
      sendSms: false,
      sendEmail: false,
    },
  };
}

export function mapCampaignToWizardData(campaign) {
  if (!campaign) {
    return getEmptyCampaignWizardData();
  }

  const startDate = campaign.start_date || null;
  const expirationDate = campaign.expiration_date || campaign.end_date || null;
  const rawType = campaign.campaign_type || campaign.type || "";
  const category = campaign.category || (CATEGORY_OPTIONS.includes(rawType) ? rawType : "");
  const scheduleType = inferScheduleType(campaign);

  return {
    basic: {
      title: campaign.title || "",
      description: campaign.desc || campaign.description || "",
      category,
    },
    schedule: {
      type: scheduleType,
      sendImmediately:
        toBoolean(campaign.start_immediately) && scheduleType === "single",
      startDate,
      startTime: getTimeValue(startDate, campaign.start_time),
      endDate: expirationDate,
    },
    audience: {
      audience_id: campaign.list_id || null,
      audience: null,
    },
    sendRules: {
      businessDaysOnly: toBoolean(campaign.business_days),
      dueDateColumnId: campaign.key_date_row ?? null,
      daysOffset:
        campaign.days_calculate === null || campaign.days_calculate === undefined
          ? ""
          : String(campaign.days_calculate),
      reference: campaign.reference_moment || "",
      ruleColumnId: campaign.key_block ?? null,
      operator: campaign.when_block || "",
      value: campaign.value_blocked || "",
    },
    channels: {
      sendWhatsapp: Boolean(campaign.whatsapp_id),
      sendSms: Boolean(campaign.sms_id),
      sendEmail: Boolean(campaign.email_id),
      whatsappChannelId: campaign.whatsapp_id || "",
      smsChannelId: campaign.sms_id || "",
      emailChannelId: campaign.email_id || "",
      whatsappTemplateId: campaign.model_whatsapp_id || "",
      smsTemplateId: campaign.model_sms_id || "",
      emailTemplateId: campaign.model_email_id || "",
    },
  };
}
